import "./AnimalFeeds.module.css";
import Header from "@/reusable_sections/Header";
import Technical from "./sections/Technical";
import Hero from "./sections/Hero";
import Footer from "@/reusable_sections/Footer";
export default function AnimalFeedsPage() {
  return <div>
      <Header />
      
      <Technical />
      <Hero />
      <Footer />
    </div>;
}